import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "flex mb-4" }
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = { class: "buttonRowWrapper" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-add" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-delete" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text-center" }

import {ErrorLocationType, PopupType} from "@/utilities/enums/Enums";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import Error from "@/components/Error.vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/GridInputFilter.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import {Store, StringHelper} from "@bryntum/grid";
import dialog from "@/components/dialog";
import RecipientlistService from "@/utilities/services/entities/RecipientlistService";
import DotMenuFactoryHelper from "@/utilities/helpers/DotMenuFactoryHelper";
import RecipientList from "@/models/entities/RecipientList";
import {updateServiceConfig} from "@/utilities/helpers/ServiceConfigHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientlistTab',
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const selectedItems = ref<Array<RecipientList>>([]);
const recipientlistService = new RecipientlistService();
let clicked = false;


const gridDataIsLoading = ref<boolean>(false);
const gridStore = new Store({
  sorters: [{
    field: 'name',
    ascending: true
  }]
})
const grid = ref(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'name',
        field: 'name',
        text: t('recipient.tabs.list.grid.name'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'recipientCount',
        field: 'recipientCount',
        text: t('recipient.tabs.list.grid.recipientCount'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'desc',
        field: 'desc',
        text: t('recipient.tabs.list.grid.desc'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id: 'editButton',
        field: 'editButton',
        text: '',
        width: 36,
        minWidth: 49,
        resizable: false,
        sortable: false,
        tooltipRenderer : () => StringHelper.xss`<span class="text-[#013C74]">${t('general.edit')}</span>`,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-edit'></span></div>`;
        },
      },
      {
        id: 'deleteButton',
        field: 'deleteButton',
        text: '',
        width: 36,
        minWidth: 49,
        resizable: false,
        sortable: false,
        tooltipRenderer : () => StringHelper.xss`<span class="text-[#013C74]">${t('general.delete')}</span>`,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-delete'></span></div>`;
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        minWidth: 49,
        resizable: false,
        type	: 'widget',
        align: "center",
        hideable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-more-menu',
          onAction : ({ source: btn }:any) => {
            const menu = DotMenuFactoryHelper.build(btn.cellInfo.record.data, [
              {
                text: t('general.details'),
                cls: 'color',
                weight: 100,
                onItem : async ({menu}:any) => {
                  await openDetailPopup(menu.record as RecipientList);
                }
              },
              {
                text: t('general.edit'),
                cls: 'color',
                weight: 100,
                onItem : async ({ menu }:any) => {
                  await openEditPopup(menu.record as RecipientList);
                }
              },
              {
                text: t('general.delete'),
                cls: 'color',
                weight: 100,
                onItem : async ({ menu }:any) => {
                  const answer = await dialog
                      .okText(t("general.delete"))
                      .cancelText(t("general.cancel"))
                      .title(t("general.deleteEntity", {entity: t("general.entities.list")}))
                      .confirm(t("recipient.tabs.list.confirmDeletionSingle", {name: menu.record.name}));

                  if (answer) {
                    const resp = await recipientlistService.delete(menu.record, ErrorLocationType.table);
                    if(!resp) return;

                    gridStore.applyChangeset({removed:[{id:menu.record.id}]});
                    globalStore.showSuccess(t('general.deleted'));
                  }
                }
              }
            ]);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      }
    ],
    listeners:{
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedItems.value = selectedItems.value.concat(event.selected.map(f=> f.data))
      selectedItems.value = selectedItems.value.filter(f => !event.deselected.map(fd => fd.data).some(fd => fd?.id === f?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.getCount();
    },
    async cellClick({column, record}:any){
      if(clicked) return;
      clicked = true;

      if(column.data.field === 'editButton'){
        await openEditPopup(record.originalData as RecipientList);
      }
      if(column.data.field === 'deleteButton'){
        const answer = await dialog
            .okText(t("general.delete"))
            .cancelText(t("general.cancel"))
            .title(t("general.deleteEntity", {entity: t("general.entities.list")}))
            .confirm(t("recipient.tabs.list.confirmDeletionSingle", {name: record.name}));

        if (answer) {
          const resp = await recipientlistService.delete(record, ErrorLocationType.table);
          if(!resp) return;

          gridStore.applyChangeset({removed:[{id:record.id}]});
          globalStore.showSuccess(t('general.deleted'));
        }
      }

      clicked = false;
    }
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig)


const setGridData = async () => {
  const resp = await recipientlistService.getForUser(ErrorLocationType.table);
  if(!resp) return;

  gridStore.data = resp;
}

const openEditPopup = async (list:RecipientList|null = null) => {
  // ensure associations are set, if the update context is used
  if(list){
    const listWithAssociations = await recipientlistService.getRecipientAssociations(list, ErrorLocationType.popup);
    if(!listWithAssociations) return;

    list = listWithAssociations;
  }

  globalStore.openPopup({
    data: list ?? new RecipientList(),
    action: async () => {
      const recipientList = globalStore.modal.contentObject as RecipientList;
      const resp = recipientList.id >= 0
          ? await recipientlistService.update(recipientList, ErrorLocationType.popup)
          : await recipientlistService.create(recipientList, ErrorLocationType.popup);
      if(!resp) return;

      if(recipientList.id < 0) {
        recipientList.id = resp.id;
        recipientList.createdAt = resp.createdAt;
        recipientList.modifiedAt = resp.modifiedAt;
      }

      // in case of an update bryntum automatically replaces the entry with the same ID
      gridStore.add(recipientList);
      await gridStore.sort(gridStore.sorters);

      globalStore.closeModal();
      globalStore.showSuccess(t("general.saved"));
    },
    resetButton:false,
    title: list
        ? t("recipient.tabs.list.popups.edit.title.update")
        : t("recipient.tabs.list.popups.edit.title.add"),
    type: PopupType.recipientlistEdit,
    big:true
  })
}

const openDetailPopup = async (list:RecipientList) => {
  const listWithAssociations = await recipientlistService.getRecipientAssociations(list, ErrorLocationType.popup);

  globalStore.openPopup({
    data: listWithAssociations ?? list,
    resetButton:false,
    title: t("recipient.tabs.list.popups.details.title"),
    type: PopupType.recipientlistDetails,
    big:true
  })
}

const deleteSelection = async () => {
  if(!selectedItems.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('general.delete'))
      .cancelText(t('general.cancel'))
      .title(t("general.deleteEntity", {entity: t("general.entities.list")}))
      .confirm(t('recipient.tabs.list.confirmDeletionMulti', {count:selectedItems.value.length}));

  if (answer) {
    let someEntriesFailed = false;

    for (const list of selectedItems.value){
      const resp = await recipientlistService.delete(list as RecipientList, ErrorLocationType.table);
      if(!resp){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:list.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("general.deleted"));
  }
}


onMounted(async ()=> {
  recalcGridHeight()
  window.addEventListener('resize', recalcGridHeight)

  gridDataIsLoading.value = true
  await updateServiceConfig();
  await setGridData();
  gridDataIsLoading.value = false
})

onBeforeUnmount(()=> {
  window.removeEventListener('resize', recalcGridHeight)

  globalStore.gridStore = null
  globalStore.gridColumnStore = null
  globalStore.currentItems = 0
  globalStore.allItems = 0
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(GridInputFilter, {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "primary symetric36 mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openEditPopup())),
            title: _unref(t)('general.add')
          }, _hoisted_7, 8, _hoisted_5),
          _createElementVNode("button", {
            class: "primary symetric36 mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteSelection())),
            disabled: !selectedItems.value.some(()=>true),
            title: _unref(t)('general.delete')
          }, _hoisted_10, 8, _hoisted_8)
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ], 512), [
      [_vShow, !gridDataIsLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, gridDataIsLoading.value]
    ])
  ]))
}
}

})